import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import clsx from "clsx";
import { useEffect, useState } from "react";
import { NavLink, useRouteMatch } from "react-router-dom";

import { Link, RoleBadge } from "@transfr-inc/dashboard-components";
import { useScreenBreakpoint } from "@transfr-inc/dashboard-components/hooks";

import { useApiRequest } from "@lib/hooks";
import { RootPath } from "@lib/routes.config";
import { Role, getRoleAvatarColor } from "@models/role";
import { useCurrentUser, useRole } from "@queries";
import { useContainer } from "@src/contexts/container-context";

import "./navbar-item.profile.scss";

export function NavbarItemProfile({ isExpanded, className }) {
  const { url: rootPath } = useRouteMatch(RootPath);
  const currentUser = useCurrentUser();
  const role = useRole();
  const { userId } = currentUser || {};
  const roleFillColor = getRoleAvatarColor(role);
  const { isMobile } = useScreenBreakpoint();
  const { userService } = useContainer();

  const [user, setUser] = useState();
  const [navLabel, setNavLabel] = useState();

  const { loading: loadingUser } = useApiRequest(() =>
    userService.getUserDetails(userId).then(setUser)
  );

  useEffect(() => {
    if (user && role != Role.STUDENT.id) {
      setNavLabel(
        `${user.firstName} ${isExpanded ? user.lastName : ""}`.trim()
      );
    } else {
      setNavLabel("Profile");
    }
  }, [user]);

  return (
    !loadingUser && (
      <Link
        routerComponent={NavLink}
        underline={false}
        to={{
          pathname: `${rootPath}/profile`,
        }}
        className={clsx(
          "profile-item",
          !isExpanded && "collapsed",
          isMobile && "mobile",
          className
        )}
      >
        <FontAwesomeIcon icon={["fasr", "circle-user"]} className="image" />
        <div className="description">
          <div
            className={clsx(
              "name",
              !isExpanded && "collapsed",
              role == Role.STUDENT.id && className
            )}
          >
            {navLabel}
          </div>
          <RoleBadge
            className="role"
            small
            role={role}
            fillColor={roleFillColor}
            tooltipEnabled
          />
        </div>
      </Link>
    )
  );
}
